export default __webpack_public_path__ + "media/images/users/user-evelyn-fisher-140x140-bf3ed49b79895a59b61beca45264dec7.jpg";